import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import {
  Form,
  Input,
  Checkbox,
  Button,
  Select,
  Tooltip,
  Switch,
  Radio,
  Icon,
  Alert,
  Modal
} from "antd";
import { getUsers, handlingDrawer } from "../../actions/UsersAction";
import { RequiredField } from "../required-field/RequiredField";
import {
  updateGroupById,
  approvedRejectedUserRequest,
  editAdminGroup
} from "../../actions/GroupAction";
import {
  sendNotification,
  permissionTranslation,
  getWithDrawer
} from "../../utils/index";
import CreateUsers from "./CreateUsers";
import {
  isFolderPermission,
  isAssetPermission,
  isDartPermission
} from "../../utils/index";
import "./create.css";
import { Spin } from "antd";
import Tree from "./Tree";
import { fetchDirectChildFolders, fetchAllFolderIds, fetchDescendantFolderIds } from "../../actions/ClientAction";
import Invitation from "../users/Invitation";


const spinnerStyle = {
  textAlign: "center",
  borderRadius: 4,
  marginBottom: 20,
  padding: "30px 50px",
  margin: "20px 0"
};

const CheckboxGroup = Checkbox.Group;

const { TextArea } = Input;

const { Option } = Select;

//const { SHOW_ALL } = TreeSelect

export class Detail extends Component {
  constructor(props) {
    super(props);

    this.listPermission = [...this.props.defaultPermissions.map(r => r.view)];

    this.assetPermissionList = this.props.defaultPermissions
      .filter(permission => isAssetPermission(permission.action))
      .map(r => r.view);
    this.folderPermissionList = this.props.defaultPermissions
      .filter(permission => isFolderPermission(permission.action))
      .map(r => r.view);
    this.dartPermissionList = this.props.defaultPermissions
      .filter(permission => isDartPermission(permission.action))
      .map(r => r.view);
    this.state = {
      name: "",
      description: "",
      options: [],
      permission: [],
      indeterminate: true,
      checkAll: false,
      allFolders: [],
      folders: [],
      lastLevelObjects: [],
      allParents: [],
      usersSelectedEmail: [],
      usersSelectedId: [],
      objectsSelectedId: [],
      objectsModified: false,
      disableControls: false,
      value: false,
      recieveEmails: true,
      checkedRadio: null,
      newCreatorGroups: false,
      optionsNewCreator: [],
      creatorGroups: [],
      showNewUserDrawer: false,
      usersCreate: null,
      // dataUsersCreate: [],
      allFoldersChecked: false,
      allFoldersCheckedBySwitch: false,
      allFolderIds: [],
      previousObjectsSelectedId: [],
      assetPermissions: [],
      allAssetPermissionsChecked: false,
      folderPermissions: [],
      allFolderPermissionsChecked: false,
      dartPermissions: [],
      allDartPermissionsChecked: false,
      showInvitationUser: false
    };
  }

  componentDidMount() {
    const { workclient } = this.props;
    this.props.getUsers(workclient, 1, null, true);
    this.handleGetData();
  }

  componentDidUpdate(prevProps) {
    const {
      data,
      updateStatus,
      detail,
      detailIsFetching,
      newUser,
      rootFolders
    } = this.props;

    if (prevProps.rootFolders !== rootFolders) {
      this.handleGetData();
    }
    const { options, value, usersCreate } = this.state;

    if (prevProps.data !== data && data.length > 0) {
      const activeUsers = data
        .filter(r => !!r.status)
        .filter(r => !r.email.includes("@bunkey"));

      this.setState({
        options: activeUsers.map((r, k) => (
          <Option key={k} value={r.email} uid={r._id}>{`${r.name} (${r.email})`}</Option>
        ))
      });

      if (detail) {
        const activeUserIds = new Set(activeUsers.map(r => r._id));
        this.setState({
          usersSelectedEmail: detail.users
            .filter(r => activeUserIds.has(r._id))
            .map(r => r.email),
          usersSelectedId: detail.users
            .filter(r => activeUserIds.has(r._id))
            .map(r => r._id)
        });
      }
    }

    // AKI HAY QUE HACER QUE SE CIERRE EL DRAWER DE DETAIL
    if (
      value &&
      prevProps.updateStatus === "" &&
      prevProps.updateStatus !== updateStatus
    ) {
      if (updateStatus === "success") this.props.handleHideDetail();
    }

    if (
      !value &&
      prevProps.updateStatus === "" &&
      prevProps.updateStatus !== updateStatus
    ) {
      this.props.handleHideDetail();
    }

    if (detail && prevProps.detail !== detail) {
      this.setState(
        {
          usersSelectedIds: [],
          usersSelectedEmail: []
        },
        () => this.loadValuesToForm()
      );

      if (detail.allowToReceiveEmail) {
        this.setState({ recieveEmails: true });
      } else {
        this.setState({ recieveEmails: false });
      }
    }

    if (
      prevProps.detailIsFetching !== detailIsFetching &&
      data &&
      data.length > 0 &&
      detail
    ) {
      const fRole = "admin";
      const fStatus = "true";

      const dataFilter = data
        .map(d => {
          if (fRole !== "all" && fRole !== d.roleLower) return null;
          else if (fStatus !== "all" && JSON.parse(fStatus) !== d.status)
            return null;
          else return d;
        })
        .filter(d => d);
      this.setState({
        // optionsNewCreator: data
        //   .filter(
        //     (r) =>
        //       r.clientRole === "admin" && r.name !== detail.userCreator.name
        //   )
        //   .filter((r) => r.status === true)
        //   .filter((r) => !r.email.includes("@bunkey"))
        //   .map((r, k) => (
        //     <Option key={k} value={r._id}>
        //       {r.name}
        //     </Option>
        //   )),
        optionsNewCreator: dataFilter.map((r, k) => (
          <Option key={k} value={r.email} uid={r._id}>
            {r.name}
          </Option>
        ))
      });
    }

    if (prevProps.newUser !== newUser && newUser) {
      this.setState({
        usersCreate: newUser
      });
    }

    if (usersCreate && options.find(r => r.props.uid === usersCreate._id)) {
      // dataUsersCreate.push(options.find(r => r.props.uid === usersCreate._id));
      this.handleOnChangeUser(usersCreate.email, usersCreate._id, true);
      this.setState({
        usersCreate: null
      });
    }
  }

  handleOnChangeName = e => {
    this.setState({
      [e.target.name]: e.target.value,
      value: true
    });
  };

  loadValuesToForm = () => {
    const { detail, authUser, intl, data } = this.props;
    const { allFolders } = this.state;
    const allFoldersLength =
      allFolders.length +
      allFolders.reduce((acum, folder) => {
        return acum + folder.allChilds.length;
      }, 0);

    if (detail) {
      // KAN-25: los grupos asignados vía Lambda pueblan objectsFilterId /
      // lastLevelObjects / objects de forma dispar; si solo se lee
      // objectsFilterId, carpetas realmente accesibles aparecen desmarcadas.
      const checkedFolderIds = [
        ...new Set(
          [
            ...(detail.objectsFilterId || []),
            ...(detail.lastLevelObjects || []),
            ...(detail.objects || [])
              .filter(r => r.type === "folder")
              .map(r => r._id)
          ].map(String)
        )
      ];

      const guarenteedPermissions = detail.permissions.filter(p => p.enabled);

      const isAllPermissionGuarenteed =
        guarenteedPermissions.length === detail.permissions.length;
      const isPermissionsIndeterminate =
        !isAllPermissionGuarenteed && guarenteedPermissions.length > 0;
      const guarenteedAssetPermissions = guarenteedPermissions
        .filter(p => isAssetPermission(p.action))
        .map(p => permissionTranslation(p.action, intl));
      const guarenteedFolderPermissions = guarenteedPermissions
        .filter(p => isFolderPermission(p.action))
        .map(p => permissionTranslation(p.action, intl));
      const guarenteedDartPermissions = guarenteedPermissions
        .filter(p => isDartPermission(p.action))
        .map(p => permissionTranslation(p.action, intl));

      this.setState({
        name: detail.name,
        description: detail.description,
        permission: detail.permissions.map(
          p => p.enabled && permissionTranslation(p.action, intl)
        ),
        usersSelectedEmail: (data.length > 0
          ? detail.users.filter(r => {
              const found = data.find(u => u._id === r._id);
              return found && !!found.status && !found.email.includes("@bunkey");
            })
          : detail.users
        ).map(r => r.email),
        usersSelectedId: (data.length > 0
          ? detail.users.filter(r => {
              const found = data.find(u => u._id === r._id);
              return found && !!found.status && !found.email.includes("@bunkey");
            })
          : detail.users
        ).map(r => r._id),
        objectsSelectedId: checkedFolderIds,
        folders: detail.objects.map(r => r._id),
        lastLevelObjects: detail.lastLevelObjects,
        allParents: detail.objects.map(r => r._id),
        disableControls:
          authUser.role === "admin" || authUser.clientRole === "admin"
            ? false
            : true,

        previousObjectsSelectedId: checkedFolderIds,
        allFoldersChecked: allFoldersLength === checkedFolderIds.length,
        indeterminate: isPermissionsIndeterminate,
        checkAll: isAllPermissionGuarenteed,

        assetPermissions: guarenteedAssetPermissions,
        allAssetPermissionsChecked:
          guarenteedAssetPermissions.length === this.assetPermissionList.length,
        folderPermissions: guarenteedFolderPermissions,
        allFolderPermissionsChecked:
          guarenteedFolderPermissions.length ===
          this.folderPermissionList.length,
        dartPermissions: guarenteedDartPermissions,
        allDartPermissionsChecked:
          guarenteedDartPermissions.length === this.dartPermissionList.length
      });
    }
  };

  handleOnChage = permission => {
    this.setState({
      permission,
      indeterminate:
        !!permission.length && permission.length < this.listPermission.length,
      checkAll: permission.length === this.listPermission.length,
      value: true
    });
  };

  onCheckAllChange = e => {
    this.setState({
      permission: e.target.checked ? this.listPermission : [],
      indeterminate: false,
      checkAll: e.target.checked,
      value: true
    });
  };
  /**
   * @name handleOnChangeUser
   * @author Modificado Por VS
   */
  handleOnChangeUser = (email, id, isCreating = null) => {
    // console.log('handleOnChangeUser.email, id, isCreating', { email, id, isCreating })

    const { data } = this.props;
    const dataFilter = data.filter(r => email.some(e => r.email.includes(e)));

    const listEmail = dataFilter.map(r => r.email);
    const listId = dataFilter.map(r => r._id);

    if (isCreating) {
      listEmail.push(email);
      listId.push(id);
    }

    // console.log('dataFilter', dataFilter)
    // const dataFilter = data
    //   .filter(r => r.status === true)
    //   .filter(r => !r.email.includes("@bunkey"));
    // const { usersSelectedEmail, usersSelectedId } = this.state;

    // let emails = usersSelectedEmail;
    // let ids = usersSelectedId;
    // //
    // if (isCreating) {
    //   emails.push(email);
    //   ids.push(id);
    // }
    // //

    // if (!isCreating) {
    //   let test_email = emails.filter(r => r !== email);
    //   let test_id = id.map(r => r.props.uid)
    //   console.log('test_email', test_email)
    //   console.log('test_id', test_id)
    // }

    this.setState({
      usersSelectedEmail: listEmail,
      usersSelectedId: listId,
      // usersSelectedEmail: isCreating ? emails : email,
      // usersSelectedId: isCreating ? ids : id.map(r => r.props.uid),
      value: true
    });
  };

  handleGetData = () => {
    const { rootFolders } = this.props;
    if (rootFolders) {
      this.setState({ allFolders: rootFolders.map(r => this.folderToTreeNode(r)) });
    }
  };

  folderToTreeNode = (r, parentAllParents = null) => {
    const allParents = parentAllParents ? parentAllParents : (r.parents || []);
    return {
      rawName: r.name,
      title:
        r.name.length > 40 ? (
          <Tooltip title={r.name} placement="left">
            {r.name.slice(0, 40)}...
          </Tooltip>
        ) : (
          r.name
        ),
      value: r._id,
      key: r._id,
      parent: allParents.slice(-1)[0] || null,
      allParents,
      allChilds: (r.childs || []).map(c => ({ id: c._id, name: c.name, type: c.type })),
      hasChildren: r.hasChildren || false,
      children: [],
      // #2 (Falabella): conteo real del subárbol (total y habilitados) para el
      // tri-estado correcto (check lleno vs indeterminado) en todos los niveles.
      descendantCount: r.descendantCount,
      selectedDescendantCount: r.selectedDescendantCount,
    };
  };

  handleLoadChildren = async (parentItem) => {
    const { workclient, detail } = this.props;
    const children = await fetchDirectChildFolders(
      workclient,
      parentItem.key,
      detail && detail._id
    );
    const parentAllParents = [
      ...parentItem.allParents,
      { _id: parentItem.key, name: parentItem.rawName, type: "folder" },
    ];
    return children.map(r => this.folderToTreeNode(r, parentAllParents));
  };

  handleLoadDescendants = folderId => {
    return fetchDescendantFolderIds(this.props.workclient, folderId);
  };

  handleOnChageAllFolders = async value => {
    // Bajo lazy-load el árbol no está completo; para "seleccionar todas" traemos
    // los _id de TODAS las carpetas del cliente (una sola vez) y se los pasamos al
    // Tree, que antes solo marcaba las raíces cargadas.
    if (value && this.state.allFolderIds.length === 0) {
      try {
        const ids = await fetchAllFolderIds(this.props.workclient);
        this.setState({ allFolderIds: (ids || []).map(String) });
      } catch (e) {
        // si falla, el Tree cae al comportamiento previo (marca lo cargado)
      }
    }

    this.setState({
      allFoldersChecked: value,
      allFoldersCheckedBySwitch: true
    });
  };
  handleSelectedFolders = objectsId => {
    const { allFolders } = this.state;
    const allFoldersLength =
      allFolders.length +
      allFolders.reduce((acum, folder) => {
        return acum + folder.allChilds.length;
      }, 0);

    this.setState({
      folders: objectsId,
      lastLevelObjects: objectsId,
      objectsSelectedId: objectsId,
      objectsModified: true,
      allFoldersChecked: allFoldersLength === objectsId.length,
      allFoldersCheckedBySwitch: false,
      value: true
    });
  };

  handleOnChageAllUsers = value => {
    const { data } = this.props;
    const dataFilter = data
      .filter(r => !!r.status)
      .filter(r => !r.email.includes("@bunkey"));

    this.setState({
      value: true,
      usersSelectedEmail: value ? dataFilter.map(r => r.email) : [],
      usersSelectedId: value ? dataFilter.map(r => r._id) : []
    });
  };

  handleShowNewUserDrawer = () => {
    this.setState(
      {
        showNewUserDrawer: true
      },
      () => this.props.handlingDrawer(true)
    );
  };

  handleHideNewUserDrawer = () => {
    this.setState(
      {
        showNewUserDrawer: false
      },
      () => this.props.handlingDrawer(false)
    );
  };

  handleSubmit = e => {
    e.preventDefault();
    const {
      name,
      description,

      usersSelectedId,
      objectsSelectedId,
      objectsModified,
      recieveEmails,
      creatorGroups,
      assetPermissions,
      folderPermissions,
      dartPermissions
    } = this.state;
    const { detail, intl, userRequests, data } = this.props;

    const mergedPermissions = [
      ...assetPermissions,
      ...folderPermissions,
      ...dartPermissions
    ];

    if (!name) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "must_enter_group" })
      );
    } else if (!description) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "must_enter_purpose" })
      );
    } /* else if (permission.length === 0) {
      sendNotification('error', intl, intl.formatMessage({ id: "must_indicate_permission" }))
    }*/ else if (
      usersSelectedId.length === 0
    ) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "must_select_user" })
      );
    } else if (objectsSelectedId.length === 0) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "must_one_folder" })
      );
    } else {
      const requestIdGroup = userRequests.filter(
        r => r.group.id === detail._id
      );
      requestIdGroup.map(r => {
        return this.props.approvedRejectedUserRequest(
          r._id,
          "rejected",
          intl,
          false
        );
      });

      let permissions = this.props.defaultPermissions.map(r => {
        const exists = mergedPermissions.find(item => item === r.view);
        return {
          action: r.action,
          enabled: exists ? true : false
        };
      });

      // Para ocultar el boton de editar administrador de grupo
      if (creatorGroups.length > 0) {
        this.props.editAdminGroup(detail._id, true);
      }

      const userCreatorGroup =
        creatorGroups.length === 0
          ? detail.userCreator
          : data.find(r => r.email === creatorGroups);

      this.props.updateGroupById(
        detail._id,
        description,
        name,
        permissions,
        usersSelectedId,
        objectsModified ? objectsSelectedId : undefined,
        objectsModified ? objectsSelectedId : undefined,
        objectsModified ? objectsSelectedId : undefined,
        recieveEmails,
        intl,
        userCreatorGroup
      );
      this.props.history.push(`/home/groups`);
    }
  };

  handleRecieveMails = e => {
    this.setState({
      recieveEmails: e.target.value,
      value: true
    });
  };

  handleShowNewCreatorGoups = () => {
    const { newCreatorGroups } = this.state;
    this.setState({
      newCreatorGroups: !newCreatorGroups
    });
  };

  handleOnChangeNewCreatorGoups = e => {
    this.setState({
      creatorGroups: e,
      value: true
    });
  };

  onChangeAllAssetsPermissions = checked => {
    this.setState((state, props) => {
      const newPermssion = checked ? [...this.assetPermissionList] : [];
      return {
        value: true,
        assetPermissions: newPermssion,
        allAssetPermissionsChecked: checked
      };
    });
  };

  handleOnChangeAssetPermission = assetPermissions => {
    this.setState({
      value: true,
      assetPermissions,
      allAssetPermissionsChecked:
        assetPermissions.length === this.assetPermissionList.length
    });
  };

  onChangeAllFolderPermissions = checked => {
    this.setState((state, props) => {
      const newPermssion = checked ? [...this.folderPermissionList] : [];
      return {
        value: true,
        folderPermissions: newPermssion,
        allFolderPermissionsChecked: checked
      };
    });
  };

  handleOnChangeFolderPermission = folderPermissions => {
    this.setState({
      value: true,
      folderPermissions,
      allFolderPermissionsChecked:
        folderPermissions.length === this.folderPermissionList.length
    });
  };

  onChangeAllDartPermissions = checked => {
    this.setState((state, props) => {
      const newPermssion = checked ? [...this.dartPermissionList] : [];
      return {
        value: true,
        dartPermissions: newPermssion,
        allDartPermissionsChecked: checked
      };
    });
  };

  handleOnChangeDartPermission = dartPermissions => {
    this.setState({
      value: true,
      dartPermissions: dartPermissions,
      allDartPermissionsChecked:
        dartPermissions.length === this.dartPermissionList.length
    });
  };

  handleHideInvitationUser = () => {
    this.setState({
      showInvitationUser: false
    });
  };

  handleShowInvitationUser = () => {
    this.setState({
      showInvitationUser: true
    });
  };

  render() {
    const {
      newColor,
      detail,
      updateIsFetching,
      intl,
      userRequests,
      hideButton,
      isFetchingAll
    } = this.props;
    const {
      options,
      name,
      description,
      disableControls,
      allFolders,
      usersSelectedEmail,
      value,
      recieveEmails,
      newCreatorGroups,
      optionsNewCreator,
      creatorGroups,
      showNewUserDrawer,
      allFoldersChecked,
      allFoldersCheckedBySwitch,
      previousObjectsSelectedId,
      assetPermissions,
      allAssetPermissionsChecked,
      allFolderPermissionsChecked,
      folderPermissions,
      allDartPermissionsChecked,
      dartPermissions,
      showInvitationUser
    } = this.state;

    const userRequestMessage = intl.formatMessage({
      id: "permission_request_user"
    });

    if (!detail)
      return (
        <div style={spinnerStyle}>
          <Spin spinning={!detail} />
        </div>
      );
    const requestAlert = userRequests.filter(r => r.group.id === detail._id);
    return (
      <Form layout="vertical" onSubmit={this.handleSubmit}>
        {requestAlert.map((r, k) => {
          return (
            <div
              style={{
                paddingBottom: 10,
                border: "1px solid #91d5ff",
                marginBottom: "13px",
                backgroundColor: "#e6f7ff"
              }}
              key={k}
            >
              <div style={{ marginTop: "6px", marginLeft: "13px" }}>
                {userRequestMessage
                  .replace("#email#", `${r.userRequire.email}`)
                  .replace("#group#", `${r.group.name}`)}
                {r.permissions.map((row, x) => (
                  <b key={x}>
                    {" "}
                    {permissionTranslation(row, intl)}
                    {r.permissions.length !== ++x && <span>, </span>}{" "}
                  </b>
                ))}
              </div>
            </div>
          );
        })}
        <Form.Item>
          <RequiredField name={intl.formatMessage({ id: "group_name" })} />
          <Input
            name="name"
            value={name}
            placeholder={intl.formatMessage({ id: "name" })}
            onChange={this.handleOnChangeName}
            disabled={disableControls}
          />
        </Form.Item>
        <Form.Item>
          <RequiredField
            name={intl.formatMessage({ id: "describe_purpose_group" })}
          />
          <TextArea
            row={4}
            name="description"
            value={description}
            placeholder={intl.formatMessage({ id: "post_description" })}
            onChange={this.handleOnChangeName}
            disabled={disableControls}
          />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({ id: "group_created" })}
          style={{ width: "20%" }}
        >
          <span>{detail && detail.userCreator.name}</span>
          {(hideButton || !hideButton.updateAdmiGroup) && (
            <Button
              style={{ marginLeft: "10px" }}
              size="small"
              onClick={this.handleShowNewCreatorGoups}
            >
              <Icon type="edit" />
            </Button>
          )}
        </Form.Item>
        {newCreatorGroups && (
          <div style={{ marginTop: "-59px", marginLeft: "175px" }}>
            {optionsNewCreator.length === 0 && (
              <Alert
                style={{ marginBottom: "8px", width: "100%" }}
                message={intl.formatMessage({ id: "not_have_administrator" })}
                type="info"
                showIcon
              />
            )}
            <Form.Item style={{ width: "100%" }}>
              {optionsNewCreator.length > 0 && (
                <Select
                  value={creatorGroups}
                  onChange={this.handleOnChangeNewCreatorGoups}
                  placeholder={intl.formatMessage({ id: "new_administrator" })}
                >
                  {optionsNewCreator}
                </Select>
              )}
            </Form.Item>
          </div>
        )}
        <Form.Item label={intl.formatMessage({ id: "group_users" })}>
          <span>
            {intl.formatMessage({ id: "select_all" })}:
            <span className="space-switch">
              <Switch
                disabled={disableControls}
                checkedChildren={intl.formatMessage({ id: "yes" })}
                onChange={this.handleOnChageAllUsers}
                unCheckedChildren={intl.formatMessage({ id: "no" })}
                defaultChecked={false}
              />
            </span>
          </span>
          {/* <Button
            style={{ marginLeft: '10px' }}
            size="small"
            onClick={this.handleShowNewUserDrawer}
          >{intl.formatMessage({ id: "new_user" })}</Button> */}
          <Button
            style={{ marginLeft: "10px" }}
            size="small"
            onClick={this.handleShowInvitationUser}
          >
            {intl.formatMessage({ id: "send_invitation" })}
          </Button>
          <Select
            dropdownMenuStyle={{ height: 400 }}
            mode="multiple"
            placeholder={intl.formatMessage({ id: "select" })}
            onChange={this.handleOnChangeUser}
            style={{ width: "100%" }}
            value={usersSelectedEmail}
            disabled={disableControls}
          >
            {options}
          </Select>
        </Form.Item>
        <Form.Item>
          <label style={{ color: "rgba(0, 0, 0, 0.85)" }}>
            {intl.formatMessage({ id: "define_the_permissions" })}
          </label>
          <div style={{ top: "-8px", position: "relative" }}>
            <span style={{ color: "#bfbfbf" }}>
              {intl.formatMessage({ id: "what_users_group" })}
            </span>
          </div>

          <div
            style={{
              borderBottom: "1px solid #E9E9E9",
              marginBottom: 10,
              paddingBottom: 10,
              marginTop: 10
            }}
          >
            <div className="title-bar" style={{ marginLeft: "0px" }}>
              <span>{intl.formatMessage({ id: "assets_title" })}</span>
            </div>
            <div>
              <span>
                {intl.formatMessage({ id: "select_all" })}:
                <span className="space-switch">
                  <Switch
                    checkedChildren={intl.formatMessage({ id: "yes" })}
                    onChange={this.onChangeAllAssetsPermissions}
                    unCheckedChildren={intl.formatMessage({ id: "no" })}
                    checked={allAssetPermissionsChecked}
                  />
                </span>
              </span>
            </div>
            <div className="group-create">
              <CheckboxGroup
                options={this.assetPermissionList}
                value={assetPermissions}
                onChange={this.handleOnChangeAssetPermission}
              />
            </div>
          </div>

          <div
            style={{
              borderBottom: "1px solid #E9E9E9",
              marginBottom: 10,
              paddingBottom: 10,
              marginTop: 10
            }}
          >
            <div className="title-bar" style={{ marginLeft: "0px" }}>
              <span>{intl.formatMessage({ id: "folders" })}</span>
            </div>
            <div>
              <span>
                {intl.formatMessage({ id: "select_all" })}:
                <span className="space-switch">
                  <Switch
                    checkedChildren={intl.formatMessage({ id: "yes" })}
                    onChange={this.onChangeAllFolderPermissions}
                    unCheckedChildren={intl.formatMessage({ id: "no" })}
                    checked={allFolderPermissionsChecked}
                  />
                </span>
              </span>
            </div>
            <div className="group-create">
              <CheckboxGroup
                options={this.folderPermissionList}
                value={folderPermissions}
                onChange={this.handleOnChangeFolderPermission}
              />
            </div>
          </div>

          <div
            style={{
              borderBottom: "1px solid #E9E9E9",
              marginBottom: 10,
              paddingBottom: 10,
              marginTop: 10
            }}
          >
            <div className="title-bar" style={{ marginLeft: "0px" }}>
              <span>{intl.formatMessage({ id: "comments_title" })}</span>
            </div>
            <div>
              <span>
                {intl.formatMessage({ id: "select_all" })}:
                <span className="space-switch">
                  <Switch
                    checkedChildren={intl.formatMessage({ id: "yes" })}
                    onChange={this.onChangeAllDartPermissions}
                    unCheckedChildren={intl.formatMessage({ id: "no" })}
                    checked={allDartPermissionsChecked}
                  />
                </span>
              </span>
            </div>
            <div className="group-create">
              <CheckboxGroup
                options={this.dartPermissionList}
                value={dartPermissions}
                onChange={this.handleOnChangeDartPermission}
              />
            </div>
          </div>
        </Form.Item>
        <Form.Item>
          <label style={{ color: "rgba(0, 0, 0, 0.85)" }}>
            {intl.formatMessage({ id: "group_folder" })}
          </label>
          <div style={{ top: "-8px", position: "relative" }}>
            <span style={{ color: "#bfbfbf" }}>
              {intl.formatMessage({ id: "choose_bunker" })}
            </span>
          </div>
          {/* <div>
            <span>{intl.formatMessage({ id: 'select' })}: <Switch disabled={disableControls} checkedChildren={intl.formatMessage({ id: 'all' })} onChange={this.handleOnChageAllFolders} unCheckedChildren={intl.formatMessage({ id: 'none' })} defaultChecked={false} /></span>
          </div>
          
          <TreeSelect
            dropdownStyle={{ width: 300, height: 400 }}
            value={objectsSelectedId}
            treeData={allFolders}
            onChange={this.onChangeFolder}
            treeCheckable={true}
            showCheckedStrategy={SHOW_ALL}
            disabled={disableControls}
            searchPlaceholder={intl.formatMessage({ id: 'select' })}
          /> */}
          <div>
            <span>
              {intl.formatMessage({ id: "select_all" })}:
              <span className="space-switch">
                <Switch
                  checkedChildren={intl.formatMessage({ id: "yes" })}
                  onChange={this.handleOnChageAllFolders}
                  unCheckedChildren={intl.formatMessage({ id: "no" })}
                  checked={this.state.allFoldersChecked}
                  disabled={isFetchingAll}
                />
              </span>
            </span>
          </div>
          {isFetchingAll ? (
            <div style={spinnerStyle}>
              <Spin spinning />
            </div>
          ) : (
            <Tree
              data={allFolders}
              defaultIds={previousObjectsSelectedId}
              allFoldersChecked={allFoldersChecked}
              allFoldersCheckedBySwitch={allFoldersCheckedBySwitch}
              allFolderIds={this.state.allFolderIds}
              handleSelectedFolders={this.handleSelectedFolders}
              onLoadChildren={this.handleLoadChildren}
              onLoadDescendants={this.handleLoadDescendants}
            />
          )}
        </Form.Item>
        <Form.Item>
          <span>{intl.formatMessage({ id: "recieve_email" })}</span>
          <Radio.Group
            onChange={this.handleRecieveMails}
            defaultChecked={recieveEmails}
            value={recieveEmails}
          >
            <Radio style={{ marginLeft: "15px" }} value={true}>
              {intl.formatMessage({ id: "yes" })}
            </Radio>
            <Radio value={false}>No</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              loading={updateIsFetching}
              htmlType="submit"
              type="primary"
              style={{
                backgroundColor: newColor,
                borderColor: newColor,
                marginBottom: 5,
                color: "#fff"
              }}
              disabled={disableControls || !value}
            >
              {intl.formatMessage({ id: "edit_asset" })}
            </Button>
            &emsp;
            <Button
              type="default"
              onClick={() => {
                this.props.handleHideDetail();
                this.props.editAdminGroup(detail._id, false);
              }}
              style={{
                backgroundColor: newColor,
                borderColor: newColor,
                color: "#fff",
                marginBottom: 5
              }}
            >
              {intl.formatMessage({ id: "cancel_button" })}
            </Button>
          </div>
        </Form.Item>
        <Modal
          title={intl.formatMessage({ id: "new_user" })}
          closable={true}
          width={getWithDrawer()}
          destroyOnClose={true}
          footer={null}
          onCancel={this.handleHideNewUserDrawer}
          onClose={this.handleHideNewUserDrawer}
          visible={showNewUserDrawer}
        >
          <CreateUsers handleHideNewUserDrawer={this.handleHideNewUserDrawer} />
        </Modal>
        <Modal
          title={intl.formatMessage({ id: "send_invitation" })}
          width={getWithDrawer()}
          closable={true}
          footer={null}
          onCancel={this.handleHideInvitationUser}
          onClose={this.handleHideInvitationUser}
          visible={showInvitationUser}
        >
          {showInvitationUser && (
            <Invitation
              showGroup={false}
              handleHideinvitationUser={this.handleHideInvitationUser}
            />
          )}
        </Modal>
      </Form>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    authUser: state.authUser.user,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    workclient: state.client.workclient,
    data: state.users.data,
    updateIsFetching: state.group.updateIsFetching,
    detail: state.group.detail,
    updateStatus: state.group.updateStatus,
    rootFolders: state.client.rootFolders,
    isFetchingAll: state.client.isFetchingRootFolders,
    userRequests: state.notifications.userRequests,
    group: state.group.byClientData,
    detailIsFetching: state.group.detailIsFetching,
    isFetching: state.notifications.isFetching,
    jobs: state.notifications.jobs,
    newUser: state.users.newUser,
    userExist: state.users.userExist,
    hideButton: state.group.hideButton,
    userAddStatus: state.users.userAddStatus,
    defaultPermissions: state.group.defaultPermissions.map(p => {
      return { ...p, view: permissionTranslation(p.action, ownProps.intl) };
    })
  };
};

const mapDispatchToProps = {
  getUsers,
  updateGroupById,
  approvedRejectedUserRequest,
  editAdminGroup,
  handlingDrawer
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Detail))
);
